import { render, staticRenderFns } from "./modalSimulacaoRegra.vue?vue&type=template&id=42bc0817&scoped=true"
import script from "./modalSimulacaoRegra.vue?vue&type=script&lang=js"
export * from "./modalSimulacaoRegra.vue?vue&type=script&lang=js"
import style0 from "./modalSimulacaoRegra.vue?vue&type=style&index=0&id=42bc0817&prod&scoped=true&lang=css"
import style1 from "./modalSimulacaoRegra.vue?vue&type=style&index=1&id=42bc0817&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42bc0817",
  null
  
)

export default component.exports